<template>
  <div :class="classes">
    <pt-page-title :title="detail.fullName"></pt-page-title>
    <!-- <pt-sub-title title="分/子公司信息"></pt-sub-title> -->
    <pt-page-menu-filter :tabs="tabs" v-model="selectTab"></pt-page-menu-filter>
    <payment-message v-if="selectTab==='payment'" :data="paymentDetail" v-loading="paymentLoading"></payment-message>
    <template v-else>
      <div :class="$style['pt-branch-company-detail']" v-loading="detailLoading">
        <table>
          <tr>
            <td>公司名称：</td>
            <td>{{detail.fullName}}</td>
          </tr>
          <tr>
            <td>简称：</td>
            <td>{{detail.name}}</td>
          </tr>
          <tr>
            <td>公司性质：</td>
            <td>{{detail.typeName}}</td>
          </tr>
          <tr>
            <td>业务类型：</td>
            <td>{{detail.business}}</td>
          </tr>
          <tr>
            <td>地区：</td>
            <td>{{detail.addresses}}</td>
          </tr>
          <tr>
            <td>收款方名称：</td>
            <td>{{detail.payeeName||"--"}}</td>
          </tr>
          <tr>
            <td>电话号码：</td>
            <td>{{detail.telephone||'--'}}</td>
          </tr>
          <tr>
            <td>条码号前缀：</td>
            <td>{{detail.codePrefix?detail.codePrefix:'--'}}</td>
          </tr>
					<tr>
						<td>CPS系统ID</td>
						<td>{{detail.externalId||'--'}}</td>
					</tr>
          <!-- <tr>
            <td>微信特约商户号：</td>
            <td>{{detail.weChatMerchantCode?detail.weChatMerchantCode:'--'}}</td>
          </tr>
          <tr>
            <td>支付宝授权应用APPID：</td>
            <td>{{detail.alipayAuthAppId||'--'}}</td>
          </tr> -->
        </table>
      </div>
      <el-button type="primary" @click="goEdit(detail.id)">编辑</el-button>
    </template>
  </div>
</template>

<script>
// 组件class前缀
import { companyTabs } from '../pt-branch-company/branch-company'
import paymentMessage from './payment-message'
const prefixCls = 'pt-branch-company-detail'

export default {
  name: 'pt-branch-company-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    paymentDetail: {
      type: [Object, Array],
      default: function () {
        return []
      }
    },
    detailLoading: Boolean,
    paymentLoading: Boolean
  },
  components: {
    paymentMessage
  },
  data () {
    return {
      tabs: companyTabs,
      selectTab: ''
    }
  },
  watch: {
    detail (val) {
      val.addresses = val.addresses.toString()
    },
    selectTab: {
      handler: function (val) {
        if (val === 'payment') {
          this.$emit('getOrganizationMerchant')
        } else {
          this.$emit('getDetail')
        }
      },
      immediate: true
    }
  },
  methods: {
    goEdit (id) {
      this.$router.push('/branch-company/branch-company-form/true/' + id)
    }
  }

}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
  @import "~less/var.less";

  :global {
    .pt-branch-company-detail {
      .el-checkbox+.el-checkbox {
        margin-left: 0
      }
      .wt-box{
        justify-content: flex-start;
        margin-left: -1rem
      }
      .wt-box__item{
        margin-right: .5rem
      }
    }

  }

  .pt-branch-company-detail {

    padding: 50px 20px;
    display: flex;
    flex-direction: row;

    :global table {
      tr {
        td {
          line-height: 40px;
          font-size: 16px;
        }

        :first-child {
          // width: 1.5rem;
          display: -webkit-box;
          color: @mainColor;
          justify-content: flex-end;
        }
      }
    }
    .el-checkbox+.el-checkbox {
      margin: 0
    }
  }

  .title {
    max-width: 300PX;
  }

  .images{
  // display: inline;
  width: 2rem !important;
  }
</style>
